// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper-foodspot {
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
}
.wrapper-foodspot .left {
  width: 35%;
  background: #F3F3F3;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 10px 10px 10px 15px;
}
.wrapper-foodspot .left h3 {
  font-size: 17px;
  line-height: 24px;
}
.wrapper-foodspot .left p {
  margin: 20px 0px;
  line-height: 22px;
}
.wrapper-foodspot .left a {
  text-decoration: none;
  font-weight: bold;
}
.wrapper-foodspot .right {
  width: 65%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.wrapper-foodspot .right .header-section {
  padding: 20px 0px;
  text-align: center;
  position: relative;
  border-bottom: 1px solid rgb(243, 243, 243);
}
.wrapper-foodspot .right .header-section ion-icon {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}
.wrapper-foodspot .right .input-section {
  width: 100%;
  padding: 20px;
}
.wrapper-foodspot .right .input-section p {
  margin: 20px 0px;
  line-height: 22px;
}
.wrapper-foodspot .right .input-section .input-block {
  display: flex;
  align-items: flex-start;
}
.wrapper-foodspot .right .input-section .input-block ion-input {
  border: 1px solid rgb(243, 243, 243);
  --border:1px solid rgba(243, 243, 243, 1);
  transition: all ease-in-out 1s;
  border-radius: 20px;
  margin-right: 10px;
  padding: 20px;
  --padding-end: 10px;
  --padding-start: 20px;
  --highlight-color-focused: transparent;
  --border-color: transparent;
  --box-shadow: none;
  cursor: text;
}
.wrapper-foodspot .right .input-section .input-block ion-input.error {
  border: 1px solid red;
}
.wrapper-foodspot .right .input-section .input-block ion-button {
  text-transform: capitalize;
}

.error-message span {
  color: red;
  font-size: 12px;
  padding-left: 5px;
}

ion-input.no-underline {
  --border-color: transparent;
  --box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/app/components/enter-foodspot-code-modal/enter-foodspot-code-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AAAI;EACI,UAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;AAER;AADQ;EACI,eAAA;EACA,iBAAA;AAGZ;AADQ;EACI,gBAAA;EACA,iBAAA;AAGZ;AADQ;EACI,qBAAA;EACA,iBAAA;AAGZ;AAAI;EACI,UAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;AAER;AAAQ;EACI,iBAAA;EACA,kBAAA;EACA,kBAAA;EAOA,2CAAA;AAJZ;AAFY;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AAIhB;AAAQ;EACI,WAAA;EACA,aAAA;AAEZ;AADY;EACI,gBAAA;EACA,iBAAA;AAGhB;AADY;EACI,aAAA;EACA,uBAAA;AAGhB;AAFgB;EACI,oCAAA;EACA,yCAAA;EAEA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EAEA,mBAAA;EACA,qBAAA;EACA,sCAAA;EAEA,2BAAA;EACA,kBAAA;EACA,YAAA;AACpB;AACoB;EACI,qBAAA;AACxB;AAEgB;EACI,0BAAA;AAApB;;AAOI;EACI,UAAA;EACA,eAAA;EACA,iBAAA;AAJR;;AAOA;EACI,2BAAA;EACA,kBAAA;AAJJ","sourcesContent":[".wrapper-foodspot {\n    display: flex;\n    align-items: center;\n    height: 100%;\n    width: 100%;\n    border-radius: 20px;\n    overflow: hidden;\n    .left {\n        width: 35%;\n        background: #F3F3F3;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        flex-direction: column;\n        padding: 10px 10px 10px 15px;\n        h3 {\n            font-size: 17px;\n            line-height: 24px;\n        }\n        p {\n            margin: 20px 0px;\n            line-height: 22px;\n        }\n        a {\n            text-decoration: none;\n            font-weight: bold;\n        }\n    }\n    .right {\n        width: 65%;\n        height: 100%;\n        display: flex;\n        justify-content: space-between;\n        flex-direction: column;\n\n        .header-section {\n            padding: 20px 0px;\n            text-align: center;\n            position: relative;\n            ion-icon {\n                position: absolute;\n                right: 20px;\n                top: 50%;\n                transform: translateY(-50%);\n            }\n            border-bottom: 1px solid rgba(243, 243, 243, 1);\n        }\n        .input-section {\n            width: 100%;\n            padding: 20px;\n            p {\n                margin: 20px 0px;\n                line-height: 22px;\n            }\n            .input-block {\n                display: flex;\n                align-items: flex-start;\n                ion-input {\n                    border:1px solid rgba(243, 243, 243, 1);\n                    --border:1px solid rgba(243, 243, 243, 1);\n\n                    transition: all ease-in-out 1s;\n                    border-radius: 20px;\n                    margin-right: 10px;\n                    padding: 20px;\n                    // --padding-top: 10px;\n                    --padding-end: 10px;\n                    --padding-start: 20px;\n                    --highlight-color-focused: transparent;\n                    // --highlight-color: transparent;\n                    --border-color: transparent;\n                    --box-shadow: none;\n                    cursor: text;\n\n                    &.error {\n                        border: 1px solid red;\n                    }\n                }\n                ion-button {\n                    text-transform: capitalize;\n                }\n            }\n        }\n    }\n}\n.error-message {\n    span {\n        color: red;\n        font-size: 12px;\n        padding-left: 5px;\n    }\n}\nion-input.no-underline {\n    --border-color: transparent;\n    --box-shadow: none;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
